module.exports = "/assets/0c6f466b8e6eae405c6fdefd1073d89e.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/FV.png
// module id = 2509
// module chunks = 0